import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    UNDELETE_PROMOTIONS,
    GET_PROMOTIONS_SUCCESS,
    UNDELETE_PROMOTIONS_ERROR,
}
    from "../../../actions/menu/promotions";

function* unDeletePromotionsSaga(action) {
    try {
        yield call(promotionService.UnDeletePromotions, action.payload)
        yield put({
            type: GET_PROMOTIONS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_PROMOTIONS_ERROR,error: error.data
        });
    }
}


export function* unDeletePromotionsSagaWatcher() {
    yield takeLatest(UNDELETE_PROMOTIONS, unDeletePromotionsSaga);
}